<script setup>
import VueMultiselect from "vue-multiselect";
import useAutocompleter from "@/composables/useAutocompleter";
import startupsService from "@/services/startups.service";
import {computed} from "vue";
import marketsService from "@/services/markets.service";

const props = defineProps({
    value: {
        type: [Object, Array, null],
    },
    multiple: {
        type: Boolean,
        default: false
    },
    defaultList: {
        type: Array,
        default: () => []
    },
    filter: {
        type: String,
        default: ''
    },
});

const emit = defineEmits(['input', 'changed']);
const {model, list, query, updateList} = useAutocompleter(props, getList, emit);

const actualList = computed(() => {
    let ls = [];

    if (query.value.length) {
        ls = list.value;
    } else {
        ls = [...props.defaultList];

        if (model.value) {
            if (props.multiple) {
                for (const val of model.value) {
                    if (!ls.find(item => item.id === val.id)) {
                        ls.push(val);
                    }
                }
            } else {
                if (!ls.find(item => item.id === model.value.id)) {
                    ls.push(model.value);
                }
            }
        }
    }

    return ls;
})

function getList(query) {
    if (props.filter === 'partnerships') {
        return marketsService.searchPartnershipStartups(query);
    } else {
        return startupsService.search(query);
    }
}
</script>

<template>
    <VueMultiselect
        v-model="model"
        placeholder="Select Startup"
        :options="actualList"
        :multiple="multiple"
        select-label=""
        deselect-label=""
        label="name"
        track-by="name"
        class="multiselect-mid pl-2"
        @search-change="updateList"
        @input="emit('changed')"
    />
</template>

<style scoped>

</style>
